import {AfterViewInit, Component, OnInit, Input} from '@angular/core';
import {DemographicHypeAuditorComponent} from '../demographic-hype-auditor/demographic-hype-auditor.component';
import {TranslateService} from '@ngx-translate/core';
import {ReferenceDataService} from '../../../services/reference-data/reference-data.service';
import {PdfExportService} from '../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../services/user.service';
import {CommonConstant, chartConfig, pieChartConfig} from '../../../app.constants';

@Component({
  selector: 'new-influencer-demographic',
  templateUrl: './new-influencer-demographic.component.html',
  styleUrls: ['./new-influencer-demographic.component.scss']
})
export class NewInfluencerDemographicComponent extends DemographicHypeAuditorComponent implements OnInit, AfterViewInit {
  public maxWidthGenderChart = CommonConstant.DEMOGRAPHIC_GENDER_CHART_MAX_WIDTH;
  public audienceInterestMaxValue: number;
  public overridenLegend: any;

  @Input() printMode: boolean;

  constructor(translate: TranslateService,
              referenceDataService: ReferenceDataService,
              pdfService: PdfExportService,
              userService: UserService) {
    super(translate, referenceDataService, pdfService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.pieLegend.useHTML = true;
    this.pieLegend.x = pieChartConfig.demographicLegendX;
    this.pieLegend.navigationActiveColor = '#445166';
    this.pieLegend.navigationInactiveColor = 'rgba(68,81,102,0.50)';
    this.pieLegend.navigationArrowSize = 10;
    this.pieTitleStyling = pieChartConfig.newTitleStyling;
    this.audienceInterestMaxValue = Math.max(...this.demographicData.audienceInterest.map(item => Math.round(item[1] * 100)));

    if (this.printMode) {
      this.overridenLegend = this.pieLegend;
    } else {
      this.overridenLegend = {
        ...this.pieLegend,
        width: 150,
        x: 87,
        align: 'center',
        floating: true
      };
    }
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/new-influencer-demographic/new-influencer-demographic.component.ts